// imove-behavior: 跳转到该主办方的个人主页

export default async function(ctx) {
    const { query } = ctx.payload;
  ctx.emit('routerPage', `space?host_id=${query?.host_id}`);
}